import { useAnnotationTimeTracker } from "@frontend/pages/case-workspace/hooks/use-annotation-time-tracker"
import { formatElapsedTime } from "@frontend/pages/case-workspace/lib/elapsed-time"

interface AnnotationTimeStatusBarProps {
  caseId: string | undefined
}

export function AnnotationTimeStatusBar({ caseId }: AnnotationTimeStatusBarProps) {
  const { isTrackingActive, totalSeconds } = useAnnotationTimeTracker({
    caseId,
    enabled: Boolean(caseId)
  })

  return (
    <div className="border-t border-border px-3 py-2 shrink-0 flex items-center gap-2">
      <span
        className={`size-1.5 rounded-full shrink-0 ${isTrackingActive ? "bg-green-500" : "bg-muted-foreground/50"}`}
      />
      <span className="font-mono tabular-nums text-[11px] text-muted-foreground">
        {formatElapsedTime(totalSeconds)}
      </span>
    </div>
  )
}
